<template>
  <div class="learning-details">
    <div class="learning-details-title">{{ hospitalName }}</div>
    <div class="learning-details-label-view">
      <div class="line"></div>
      <div class="title">医院简介</div>
    </div>
    <div class="learning-details-content" v-html="
      hospitalContent == ''
        ? '暂无医院简介'
        : hospitalContent == undefined
          ? '暂无医院简介'
          : hospitalContent
    "></div>
    <div class="bind-hospital-title">
      <div class="line"></div>
      <div class="title">
        导师简介 <span>| 共{{ teacherList && teacherList.length }}人</span>
      </div>
    </div>
    <div class="mywork_box">
      <template v-if="teacherList.length > 0">
        <div class="work_list" v-for="(item, index) in teacherList" :key="index">
          <div v-if="item.userHospitalTeacherApplyStatus == 4 && roleType == '4'" class="bottom-img">
            <img class="bottom-img-exclusive" src="@/assets/images/application-study/exclusive-tutor.png" alt="" />
          </div>
          <div class="bind-hospital">
            <div class="search-bottom-passhos">
              <div class="search-bottom-passhos-title">
                <div class="head">
                  <div class="headImg">
                    <van-image :src="item.headPicUrl || teacherHeadImg" :loading-icon="teacherHeadImg"
                      :error-icon="teacherHeadImg" fit="cover" round />
                  </div>
                  <div class="stuInfo">
                    <div class="stuName">{{ item && item.realName }}</div>
                    <div class="belongHospitalName">
                      {{ item && item.positionTitle }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <ExpandCollapse :expandTitle="''" :expandContent="
              item.summaryText ? item.summaryText : '暂无导师简介'
            "></ExpandCollapse>
          </div>
        </div>
      </template>
      <!-- 如果没有内容 -->
      <EmptyView v-else class="empty-view" title="暂无数据" />
    </div>
  </div>
</template>

<script>
import { educations, doctors } from '@/api/education.js'
import teacherHeadImg from '@/assets/images/home/teacher-head.png'
import ExpandCollapse from '@/components/ExpandCollapse.vue'
import EmptyView from '@/components/EmptyView.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'LearningDetails',
  components: {
    ExpandCollapse,
    EmptyView,
  },
  data () {
    return {
      hospitalName: '23',
      hospitalContent: '',
      teacherList: [],
      teacherHeadImg
    }
  },
  mounted () {
    this.handleGetEducations()
    this.handleGetDoctor()
  },
  methods: {
    // 获取医院详情
    handleGetEducations () {
      educations({
        hospitalId: this.$route.query.hospitalId
      }).then(res => {
        this.hospitalContent = res.data.intro
        this.hospitalName = res.data.name
      })
    },
    // 获取医生列表
    handleGetDoctor() {
      doctors({
        hospitalId: this.$route.query.hospitalId
      }).then(res => {
        this.teacherList = res.data
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.learning-details {

  // padding-top: 15px;
  .learning-details-title {
    padding: 0 10px;
    text-align: center;
    margin: 24px 0px;
    font-size: 17px;
    font-weight: bold;
    color: #1f333f;
  }

  // 空位
  .learning-details-vacancy {
    width: 351px;
    height: 40px;
    line-break: 40px;
    background: #ffffff;
    border-radius: 5px;
    margin: 0 12px 18px 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    justify-items: center;
    padding: 12px;
    font-size: 13px;
    font-weight: 500;
    color: #1f333f;

    // 空位名额左
    .learning-details-vacancy-left {
      font-weight: bold;
      color: #1f333f;

      span {
        color: #007eff;
      }
    }

    // 空位名额右
    .learning-details-vacancy-right {
      display: flex;
      flex-direction: row;
      justify-items: center;

      // 空位名额右修改
      .learning-details-vacancy-right-one {
        width: 60px;
        display: flex;
        justify-items: center;
        padding-right: 10px;
        height: 16px;
        line-height: 16px;

        // 空位名额右修改图片
        .learning-details-vacancy-img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }

      // 空位名额右历史
      .learning-details-vacancy-right-two {
        width: 60px;
        display: flex;
        justify-items: center;
        padding-left: 10px;
        border-left: 1px solid #999999;
        height: 16px;
        line-height: 16px;

        // 空位名额右历史图片
        .learning-details-vacancy-img {
          width: 16px;
          height: 16px;

          margin-right: 5px;
        }
      }
    }
  }

  // 医院简介
  .learning-details-label-view {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    position: relative;
    margin-left: 12px;

    .line {
      width: 4px;
      height: 12px;
      background: #fe6a23;
      border-radius: 2px;
      margin-right: 7px;
      line-height: 15px;
    }

    .title {
      height: 15px;
      font-size: 15px;
      font-weight: 800;
      color: #1f333f;
      line-height: 15px;
    }
  }

  .learning-details-content {
    font-size: 14px;
    width: 351px;
    background: #ffffff;
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    padding: 16px 13px;
    margin: 0 12px;
    font-size: 13px;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    min-height: 120px;
  }

  .bind-hospital-title {
    display: flex;
    align-items: center;
    margin-top: 18px;
    margin-bottom: 15px;
    position: relative;
    margin-left: 12px;

    .line {
      width: 4px;
      height: 12px;
      background: #fe6a23;
      border-radius: 2px;
      margin-right: 7px;
      line-height: 15px;
    }

    .title {
      height: 15px;
      font-size: 15px;
      font-weight: 800;
      color: #1f333f;
      line-height: 15px;

      span {
        font-size: 11px;
        font-weight: 500;
        color: #1f333f;
        line-height: 15px;
      }
    }
  }

  .mywork_box {
    // height: calc(100vh - 46px);
    background: #f8f8f8;
    padding: 0 12px 19px 12px;
    box-sizing: border-box;
    overflow: auto;

    h2,
    h3,
    p {
      margin: 0;
    }

    .work_list {
      padding: 16px 12px 20px 12px;
      background: #fff;
      border-radius: 3px;
      margin-bottom: 15px;
      position: relative;

      .bottom-img {
        position: absolute;
        right: -2px;
        top: -2px;

        .bottom-img-exclusive {
          width: 57px;
          height: 57px;
        }
      }

      // 需绑定的医院
      .bind-hospital {
        .search-bottom-passhos {

          // 搜索框底部固定医院标题样式
          .search-bottom-passhos-title {
            font-size: 15px;
            font-weight: bold;
            color: #1f333f;

            // height: 14px;
            .head {
              align-items: center;
              display: flex;
              padding-bottom: 15px;

              // border-bottom: 1px solid #e4e4e4;
              .headImg {
                width: 45px;
                height: 45px;
                border-radius: 50%;
                margin-right: 8px;
              }

              ::v-deep(.van-icon__image) {
                width: 45px;
                height: 45px;
              }

              .stuInfo {
                .stuName {
                  font-size: 13px;
                  font-weight: bold;
                  color: #1f333f;
                  padding-bottom: 8px;
                  line-height: 1;
                  width: 210px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .belongHospitalName {
                  font-weight: 500;
                  font-size: 11px;
                  color: #999999;
                  line-height: 1;
                  width: 217px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }

      .workList_title {
        color: #434040;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        padding-left: 20px;
        position: relative;
        font-family: Source Han Sans CN, Source Han Sans CN;

        &::after {
          content: '';
          width: 2px;
          height: 15px;
          background: #007eff;
          position: absolute;
          left: 0;
          top: 4px;
        }
      }

      .bottom {
        position: relative;

        .work_neirong {
          // padding: 0 10px;
          box-sizing: border-box;
          // background: rgba(213, 213, 213, 0.08);
          // border: 1px solid #ececec;
          overflow: auto;
          // transition: all 1s linear;

          .neirongList {
            .neirong_title {
              font-size: 13px;
              font-weight: 500;
              color: #333333;
              line-height: 22px;
              margin: 0;
            }

            // .neirong_nav {
            //   font-size: 12px;
            //   padding: 5px;
            //   color: #999;
            //   line-height: 20px;
            //   box-sizing: border-box;
            //   border-bottom: 1px solid #f1f1f1;
            // }
          }
        }

        .small_height {
          max-height: 120px;
        }

        .more_height {
          max-height: 2000px;
        }

        .moreText-button {
          position: relative;
        }

        .moreText {
          height: 60px;
          text-align: center;
          font-size: 12px;
          color: #999;
          // box-shadow: 0px -15px 20px -6px black;
          border-top: 1px solid #ffffff;
          background: #ffffff;
          position: absolute;
          z-index: 999;
          width: 100%;
          top: -60px;
        }

        .bottom-center {
          flex-direction: row;
          justify-content: center;
          display: flex;
          margin-top: 10px;

          .open-close {
            width: 54px;
            height: 20px;
            border: 1px solid #999999;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            color: #999;
          }
        }

        .bottom-button {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          height: 32px;

          // 报名
          .sign-up {
            text-align: center;
            color: #ffffff;
            width: 158px;
            height: 32px;
            background: #EB1700;
            border-radius: 16px;
            line-height: 32px;
            font-size: 14px;
          }

          // 撤回报名
          .withdrawal-name {
            text-align: center;
            color: #fe902e;
            width: 158px;
            height: 32px;
            line-height: 32px;
            background: #ffffff;
            border: 1px solid #fe6a23;
            border-radius: 16px;
            font-size: 14px;
          }

          // 查看申请
          .view-application {
            margin-left: 15px;
            text-align: center;
            color: #ffffff;
            width: 158px;
            height: 32px;
            background: #EB1700;
            border-radius: 16px;
            line-height: 32px;
            font-size: 14px;
          }
        }
      }
    }

    .empty-view {
      height: 200px;
    }
  }
}

::v-deep(.van-popup--center.van-popup--round) {
  border-radius: 5px;
}

.show-edit {
  width: 260px;
  height: 149px;
  background: #ffffff;
  border-radius: 5px;
  padding: 20px 0 0 0;

  .show-edit-title {
    height: 15px;
    font-size: 15px;
    font-weight: bold;
    color: #1f333f;
    line-height: 15px;
    text-align: center;
    margin: 0 20px 16px 20px;
  }

  .show-edit-input {
    padding: 0 20px 18px 20px;
    border-bottom: 1px solid #e4e4e4;

    ::v-deep(.van-cell-group--inset) {
      margin: 0;
    }

    ::v-deep(.van-cell) {
      background: #f4f4f4;
      height: 36px;
      line-height: 16px;
      border-radius: 5px;
    }
  }

  .show-edit-bottom {
    height: 43px;
    // border-top: 1px solid #e4e4e4;
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    margin-right: 20px;

    .show-edit-bottom-cancel {
      width: 130px;
      font-size: 14px;
      font-weight: bold;
      color: #1f333f;
      line-height: 43px;
      text-align: center;
    }

    .show-edit-bottom-save {
      width: 130px;
      font-size: 14px;
      font-weight: bold;
      color: #fe6a23;
      line-height: 43px;
      text-align: center;
    }
  }
}

.show-history {
  width: 351px;
  height: 175px;
  background: #ffffff;
  border-radius: 5px;
  padding: 20px 0 20px 0;

  .show-history-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 20px;
    position: relative;

    .line {
      width: 4px;
      height: 12px;
      background: #fe6a23;
      border-radius: 2px;
      margin-right: 7px;
      line-height: 15px;
    }

    .title {
      height: 15px;
      font-size: 15px;
      font-weight: 800;
      color: #1f333f;
      line-height: 15px;
    }
  }

  .vacancyWrap {
    max-height: 103px;
    overflow-y: auto;
    padding: 0 20px;
  }

  .show-history-content {
    margin-bottom: 16px;

    .show-history-content-count {
      height: 13px;
      font-size: 13px;
      font-weight: 500;
      color: #1f333f;
      line-height: 13px;

      .newAssignCount {
        color: #007eff;
      }

      .createTime {
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/application-study/learning-details.vue